const HOVER_SUFFIX = ':hover';
export default {
    getDefaultId: (id) => id === null || id === void 0 ? void 0 : id.replace(HOVER_SUFFIX, ''),
};
//# sourceMappingURL=utils.js.map